const installationInstructions = {
  intro: {
    currentStep: 'intro',
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/device-models/EW020/light_strip_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.light_strip.powerDevice.title',
    secondaryTx: 'categories.light_strip.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      lastStep: 'intro',
      titleTx: 'categories.light_strip.stepsToReset',
    },
  },
  letsGetStarted: {
    currentStep: 'letsGetStarted',
    prevStep: 'intro',
    prevStepName: 'instructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/device-models/EW020/light_strip_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.light_strip.confirmPairingMode.title',
    secondaryTx: 'categories.light_strip.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      lastStep: 'letsGetStarted',
      titleTx: 'categories.light_strip.stepsToReset',
    },
  },
  pairingModeReset: {
    headerIcon: 'closeBlack',
    prevStep: 'intro',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.light_strip.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/categories/appliance/reset_appliance_step_1.png'),
          primaryTx: 'categories.light_strip.resetDevice.step1.title',
          secondaryTx: 'categories.light_strip.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/appliance/reset_appliance_step_2.png'),
          primaryTx: 'categories.light_strip.resetDevice.step2.title',
          secondaryTx: 'categories.light_strip.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/device-models/EW020/reset_light_strip_step_3.gif'),
          primaryTx: 'categories.light_strip.resetDevice.step3.title',
          secondaryTx: 'categories.light_strip.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
